<div class="mat-elevation-z8 comments-container">
  <mat-tab-group>
    <mat-tab *ngFor="let type of userTypes" [label]="type">
      <div class="comments-list">
        <div *ngFor="let comment of comments" class="comment-item">
          <div class="comment-content">
            <p>{{ comment.text }}</p>
            <div *ngFor="let reply of comment.replies">
              <p><strong>Reply:</strong> {{ reply.text }}</p>
            </div>
            <div *ngIf="comment.attachments">
              <p><strong>Attachments:</strong></p>
              <ul>
                <li *ngFor="let attachment of comment.attachments">{{ attachment }}</li>
              </ul>
            </div>
          </div>
          <div class="comment-metadata">
            {{ comment.user }} - {{ comment.timestamp | date:'short' }}
          </div>
          <button mat-icon-button aria-label="Reply to comment" (click)="replyToComment(comment.id)">
            <mat-icon class="nav-icon">reply</mat-icon>
          </button>
          <button mat-icon-button aria-label="Attach file" (click)="fileInput.click()">
            <mat-icon class="nav-icon">attach_file</mat-icon>
          </button>
          <input type="file" #fileInput (change)="onFileSelected($event, comment.id)" style="display: none;">
        </div>
      </div>
      <div class="comment-input-container">
        <input type="text" [(ngModel)]="newCommentText" placeholder="Type your comment & hit enter" />
        <button (click)="postComment()"><mat-icon>send</mat-icon></button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

